'use strict';
/**
 * Some useful packages (you can install by using npm)
 * 1. slick-carousel (pre-installed) = Simple, easy, responsive carousel (buggy centerMode - variableWidth - lazyMode)
 * 2. jquery-match-height (pre-installed) = Use this to match the height of elements. Either use this or Equalizer from Foundation
 *
 * IMPORTANT:
 * To import async-ly, you need to wrap your codes in require.ensure([], () => { });
 * It's best not to async plugins, to leverage browser cache
 * Ref: https://webpack.js.org/guides/code-splitting/
 *
 * NOTES:
 * This boilerplate uses CDN/external for jQuery/React package. Configured in gulp/webpack.js.
 * This to prevent the needs of jQuery/React from node_modules
 */

///////////////
// Libraries //
///////////////

///////////////////
// Umbraco Forms //
///////////////////
/**
 * 	There are two types umbraco forms: Umbraco Forms and Contour Forms
 * 	The one we're using is the Umbraco Forms.
 * 	The source of below scripts are from SundownersOverland.Web/App_Plugins/UmbracoForms/Assets/themes/default/*.js
 *
 *  Countour Form ones are from SundownersOverland.Web/App_Plugins/UmbracoForms/Assets/*.js
 */
// import './custom_vendors/umbracoforms-dependencies';
// import './custom_vendors/umbracoforms';
// import './custom_vendors/umbracoforms-conditions';

// autocomple tags
import './custom_vendors/bootstrap-tagsinput';


// Don't know why babel doesn't transpile ssm. Changed to the minified one
import * as conditioner from 'conditioner-core';
// import ssm from 'simplestatemanager';
import JSON5 from 'json5';

import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes';

// Note for lazysizes
// Need to do "mobile size first"
// If you define bgset="imageA sizeA, imageB sizeB", then if the B is loaded first, the A won't load although it matches the size requirement
// If you define bgset="imageA sizeA, imageB sizeB", then if the A is loaded first, B will load if it matches the size requirement

// To define with media query, do the ones that have mediaquery first, then the ones without
// If you define with media query, it will load based on the set media query

window.lazySizesConfig.lazyClass = 'js-lazysizes';
window.lazySizesConfig.loadedClass = 'is-lazysizes-loaded';
window.lazySizesConfig.loadingClass = 'is-lazysizes-loading';

/////////////
// Plugins //
/////////////
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/alert';

////////////////
// Utils      //
////////////////
import HeaderUtil from './modules/HeaderUtil';

// Setting Webpack public path dynamically so that it loads the utils
// from the folder where the main.js is located
var bundleSrc = $('[src*="/main.js"]').attr("src");
__webpack_public_path__ = bundleSrc.substr(0, bundleSrc.lastIndexOf("/") + 1);

$(() => {
	///////////////////////////////
	// Dynamic Lazy Load Modules //
	///////////////////////////////
	conditioner.addPlugin({
		// converts module aliases to paths
		moduleSetName: name => `${name}`,

		// use default exports as constructor
		moduleGetConstructor: module => module,

		moduleImport: name => import(/* webpackMode: "lazy"*/ /* webpackChunkName: "[request]"*/ `./modules/${name}`)
	});
	conditioner.hydrate(document.documentElement);

	//////////////////////
    // Responsive Table //
    //////////////////////
    const $table = $('.o-richtext table:not([class])');
    if ($table.length) {
        $table.wrap('<div class="u-table-responsive">');
    }

	////////////
	// Header //
	////////////
	HeaderUtil.initMegamenu();
	HeaderUtil.initCloseOffCanvas();


   
			
	$("#alertbtn").click(function(){
		toastr.error('Hey, this is message when get error!')
	})
	$("#infobtn").click(function(){
		toastr.success('Hey, this is success message!')
	})
	
});



// WEBPACK FOOTER //
// ./src/_js/main.js